import { Button } from "@ttc3k/trekker";
import { HelpCircle } from "iconoir-react";
import { Flex } from "styled-system/jsx";
import { useState } from "react";
import { ContactUsPage } from "../OverlayPages";
import { useBookerContext } from "widgets/booker/contexts";
import { CollapsableText } from "widgets/booker/shared";
import { isEventProduct } from "shared/utils";
import { useTranslation } from "react-i18next";
import { getOverriddenProductDescription } from "widgets/booker/shared/utils";

export const ContactDetails = () => {
  const [contactPageOpen, setContactPageOpen] = useState(false);

  const { product, language, booker } = useBookerContext();

  const { t } = useTranslation("booker");

  return (
    <Flex flexDir={"column"} gap={"300"}>
      {product?.description && !isEventProduct(product) && (
        <CollapsableText
          text={getOverriddenProductDescription(product, booker, language)}
          maxHeight={150}
        />
      )}
      <Button
        Icon={HelpCircle}
        isIconRightAligned={false}
        size={"lg"}
        mode={"light"}
        onClick={() => setContactPageOpen(true)}
        type="button"
      >
        {t("CONTACT_US")}
      </Button>
      <ContactUsPage
        open={contactPageOpen}
        onClose={() => setContactPageOpen(false)}
      />
    </Flex>
  );
};
